export default "{\n    \"label\": \"Tipo de activo\",\n    \"placeholder\": \"Seleccione tipo de activo\"\n}\n"